<template>
    <div id="current">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=1></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="list flex app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div class="box" v-for="(item, index) in arrList" :key="index">
                <img :src="item.image" alt="" class="pic">
                <p class="tips">{{ tipsLabel }}</p>
                <p class="tit app-title">{{ item.title }}</p>
                <p class="tim">{{ item.start_time }} - {{ item.end_time }}</p>
                <p class="where">{{item.show_location}}</p>
                <p class="con">{{ item.content }}</p>
                <div class="tocon flex" @click="todetails(item.id)">
                    <p>{{ toconLabel }}</p>
                    <img src="../assets/back.png" alt="">
                </div>
            </div>
            <div class="box" v-if="arrList.length % 3 == 2"></div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import router from '@/router';
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);

    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    const titleLabel = computed(() => backheadTitles.current[currentLanguage.value || 'zh'])
    const tipsLabel = computed(() => pageLabels.current.intro[currentLanguage.value || 'zh'])
    const toconLabel = computed(() => pageLabels.current.details[currentLanguage.value || 'zh'])

    // 跳详情
    function todetails(id) {
        router.push("/details?pid=1&id=" + id)
    }
    // 获取列表数据
    function getList() {
        let queryParams = {
            pid: 1,
            page: 1,
            pageSize: 100,
            show_status: 1
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                item.content = item.content.replace(/<[^>]*>/g, '')
                item.start_time = item.start_time.slice(0, 4) + '年' + item.start_time.slice(5, 7) + '月' + item.start_time.slice(8, 10) + '日'
                item.end_time = item.end_time.slice(0, 4) + '年' + item.end_time.slice(5, 7) + '月' + item.end_time.slice(8, 10) + '日'
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #current{
        overflow: hidden;
    }
    .list{
        margin-top: 200px;
        flex-wrap: wrap;
        padding: 30px 60px;
        align-items: flex-start;
        .box{
            padding: 50px 0;
            width: 30%;
            font-size: 16px;
            color: #727272;
            text-align: left;
            .pic{
                width: 100%;
                height: 288px;
                object-fit: cover;
            }
            .tips{
                font-size: 18px;
                margin: 10px 0;
            }
            .tit{
                /* font-weight: bold; */
                font-size: 22px;
                color: #000;
                margin-bottom: 10px;
                /* font-family: 'OPPOSansH', sans-serif; */
            }
            .con{
                font-size: 17px;
                color: #000;
                margin-top: 10px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                /*设置省略号在容器第四行文本后*/
                -webkit-line-clamp: 4; 
                overflow: hidden;

            }
            .tocon{
                justify-content: flex-start;
                padding-top: 90px;
                cursor: pointer;
                p{
                    font-size: 20px;
                    color: #000;
                }
                img{
                    width: 10px;
                    height: 10px;
                    transform: rotate(180deg);
                    margin-left: 20px
                }
            }
        }
    }
    .Mobileclass{
        display: block;
        margin-top: 160px;
        padding: 0 22px;
        .box{
            width: 100%;
            &:first-child{
                padding-top: 0;
            }
        }
    }
</style>